import React, {PropTypes as pt} from 'react';
import classNames from 'classnames';

class Checkbox extends React.Component {
    handleChange = e => this.props.onChange(this.props.name, e.target.checked);

    render() {
        const {value, label, disabled, name, checked, className} = this.props;
        const classes = classNames({
            checkbox: true,
            [className]: true,
        });
        return (
            <div className={classes}>
                <label>
                    <input
                        type="checkbox"
                        name={name}
                        value={value}
                        onChange={this.handleChange}
                        disabled={disabled}
                        checked={checked}
                    /> {label}
                </label>
            </div>
        );
    }
}

Checkbox.propTypes = {
    name: pt.string.isRequired,
    label: pt.string.isRequired,
    value: pt.oneOfType([pt.string, pt.number]),
    onChange: pt.func.isRequired,
    disabled: pt.bool.isRequired,
    checked: pt.bool.isRequired,
    className: pt.string,
};

Checkbox.defaultProps = {
    disabled: false,
    value: '',
    checked: false,
    className: '',
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/incab/common/components/form/Checkbox.jsx